import { Button, Image, Spinner, Text, VStack, Switch, HStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { CheckFatFilledIcon, CheckFatOutlineIcon } from '@assets/icons';
import { GoogleCalendarLogo, OutlookLogo } from '@assets/images';
import { useNylasAccountStatus } from '@services/query-services/nylas.query-service';
import { useUserStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';
import NylasService from '@services/nylas.service';

const nylasService = NylasService.getInstance();

const CalendarsSetupStep = ({ setIsNextButtonDisabled }) => {
  const { data: nylasAccount, isLoading: isNylasAccountLoading } = useNylasAccountStatus();

  const isGoogleConnected = ['google', 'gmail'].includes(nylasAccount?.value?.provider);
  const isMicrosoftConnected = nylasAccount?.value?.provider === 'eas';
  const [isSkipChecked, setIsSkipChecked] = useState(false);

  useEffect(() => {
    setIsNextButtonDisabled(!isGoogleConnected && !isMicrosoftConnected && !isSkipChecked);
  }, [nylasAccount, isGoogleConnected, isMicrosoftConnected, isSkipChecked]);

  return (
    <VStack
      h='full'
      w='full'
      justify='center'
      gap={8}
    >
      <CalendarButton
        imageSrc={GoogleCalendarLogo}
        name='Google Calendar'
        isConnected={isGoogleConnected}
        isDisabled={isMicrosoftConnected}
        isNylasAccountLoading={isNylasAccountLoading}
      />
      <CalendarButton
        imageSrc={OutlookLogo}
        name='Microsoft Outlook'
        isConnected={isMicrosoftConnected}
        isDisabled={isGoogleConnected}
        isNylasAccountLoading={isNylasAccountLoading}
      />
      <HStack>
        <Switch
          isChecked={isSkipChecked}
          onChange={(e) => setIsSkipChecked(e.target.checked)}
        />
        <Text>I want to skip connecting my calendar right now</Text>
      </HStack>
    </VStack>
  );
};

const CalendarButton = ({ imageSrc, name, isConnected, isDisabled, isNylasAccountLoading }) => {
  const user = useUserStore((state) => state.user);
  const toast = useStyledToast();
  const rightIcon = isConnected ? <CheckFatFilledIcon /> : <CheckFatOutlineIcon />;

  return (
    <Button
      variant='onboarding'
      borderColor={isConnected ? 'brandPrimary.primary' : 'surface.outlineVariant'}
      isDisabled={isDisabled || isNylasAccountLoading}
      rightIcon={isNylasAccountLoading ? <Spinner /> : rightIcon}
      onClick={async () => {
        if (isConnected) {
          toast({ title: `${name} is already connected.`, status: 'success' });
        } else {
          await nylasService.connectNylasAccount(user, 3);
        }
      }}
    >
      <Image
        src={imageSrc}
        boxSize={12}
      />
      <Text
        variant='label-caps-600-sm'
        fontSize='16px'
        fontWeight={600}
      >
        {name}
      </Text>
    </Button>
  );
};

export default CalendarsSetupStep;
